<div>
    <app-events-panel [draft]="true"></app-events-panel>
</div>